import Form from '@admin/components/form'
import ColorField from '../colorfield'
import PropTypes from 'prop-types'
import React from 'react'

class OverlayField extends React.Component {

  static propTypes = {
    defaultValue: PropTypes.object,
    theme: PropTypes.object,
    value: PropTypes.object,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    overlay: null
  }

  _handleChange = _.debounce(this._handleChange.bind(this), 100, { trailing: true })
  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    if(!this.state.overlay) return null
    return (
      <div className="mjson-designer-stylefield">
        <Form { ...this._getForm() } />
      </div>
    )
  }

  componentDidMount() {
    const defaultValue = this._getDefaultValue()
    this._handleSet(defaultValue)
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.props
    const { overlay } = this.state
    if(!_.isEqual(overlay, prevState.overlay)) {
      this._handleChange()
    }
    if(!_.isEqual(value, prevProps.value)) {
      this._handleSet(value)
    }
  }

  _getDefaultValue() {
    const { defaultValue, value } = this.props
    return !_.isNil(value) ? value : !_.isNil(defaultValue) ? defaultValue : null
  }

  _getForm() {
    const { overlay } = this.state
    const { theme } = this.props
    return {
      inline: true,
      onChange: this._handleUpdate,
      sections: [
        {
          fields: [
            { name: 'apply', type: 'checkbox', defaultValue: false, prompt: 't(Apply color overlay)', value: overlay.apply },
            { label: 't(Color)', name: 'color', type: ColorField, theme, value: overlay.color, include: overlay.apply }
          ]
        }
      ]
    }
  }

  _handleChange() {
    const { overlay } = this.state
    const { apply, color } = overlay
    this.props.onChange(apply ? color : null)
  }

  _handleSet(color) {
    this.setState({
      overlay: {
        apply: !_.isNil(color),
        color: color || {
          value: '@dark',
          opacity: '50%'
        }
      }
    })
  }

  _handleUpdate(overlay) {
    this.setState({ overlay })
  }

}

export default OverlayField
